import React from 'react'
import helpDesk from '../../Assets/helpdesk.png'
import zebra from '../../Assets/zebra.png'
import './partnership.styles.scss'
import { useTranslation } from 'react-i18next'

const Partnership = () => {
    const { t } = useTranslation();

    return (
        <div className='partnership' aria-label="Sezione Helpdesk e Partnership">
            <div className='box' aria-label="Box Helpdesk">
                <div className='description'>
                    <label className='title' aria-label={t("home.helpdesk.title")}>{t("home.helpdesk.title")}</label>
                    <label className='subtitle' aria-label={t("home.helpdesk.subtitle")}>
                        {t("home.helpdesk.subtitle")}
                    </label>
                </div>
                <div className='image'>
                    <img src={helpDesk} alt="Illustrazione servizio helpdesk" />
                </div>
            </div>
            <div className='box' aria-label="Box Partnership Zebra Technologies">
                <div className='description'>
                    <label className='title' aria-label={t("home.partnership.title")}>{t("home.partnership.title")}</label>
                    <label className='subtitle' aria-label={t("home.partnership.subtitle")}>
                        {t("home.partnership.subtitle")}
                    </label>
                </div>
                <div className='image'>
                    <img src={zebra} alt="Logo Zebra Technologies, partner ufficiale" />
                </div>
            </div>
        </div>
    )
}

export default Partnership